import React from 'react';
import {IconProps} from './IconProps';

export const FacebookIcon: React.FC<IconProps> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='23.877' viewBox='0 0 24 23.877'>
        <path d='M12 0a11.993 11.993 0 0 0-1.794 23.852V15.18H7.237v-3.154h2.969v-2.1c0-3.475 1.693-5 4.581-5a16.845 16.845 0 0 1 2.461.149v2.753h-1.97c-1.226 0-1.654 1.163-1.654 2.473v1.724h3.593l-.487 3.155h-3.106v8.7A11.993 11.993 0 0 0 12 0Z' />
    </svg>
);
